import React from "react";
import { Navigate } from "react-router-dom";
import Orders from "../pages/Order";
import CreatOrder from "../pages/Order/create";
import OrderDetails from "../pages/Order/view";
import Transactions from "../pages/Transcations";
import Dashboard from "./../pages/Dashboard";
import Consumers from "../pages/Consumers";
import ConsumerTransactions from "../pages/Consumers/transactions";

const protectedRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/orders", element: <Orders /> },
  { path: "/create-order", element: <CreatOrder /> },
  { path: "/orderdetails/:id", element: <OrderDetails /> },
  { path: "/transcations", element: <Transactions /> },
  { path: "/consumers", element: <Consumers /> },
  { path: "/consumer-transactions", element: <ConsumerTransactions /> },
  { path: "*", element: <Navigate to="/" /> },
];
export default protectedRoutes;
